<template>
  <v-form
    ref='form'
    v-model='valid'
    lazy-validation
  >
    <v-text-field
      v-model='username'
      label='Логин'
      prepend-inner-icon='mdi-account'
      required
    />

    <v-text-field
      v-model='password'
      :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
      :type="passwordShow ? 'text' : 'password'"
      name='input-10-1'
      label='Пароль'
      append-inner-icon='mdi-lock'
      counter
      @click:append='passwordShow = !passwordShow'
    />

    <div class='text-center'>
      <v-btn
        :disabled='!valid'
        color='primary'
        class='mr-4'
        @click='login'
      >
        Войти
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import router from '@/router';
export default {
  name: 'AuthForm',

  data: () => ({
    valid: true,
    username: '',
    password: '',
    passwordShow: false,
  }),

  methods: {
    async login() {
      try {
        await this.$store.dispatch('fetchAuth', { username: this.username, password: this.password });
      } catch (e) {
        return;
      }
      await router.push(`/`);
    },
  },

};
</script>